import React, { Component } from "react";
import { Button } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import { Field, reduxForm } from "redux-form";
import validate from "./validations/loginValidate";
import { renderTextField } from "../../../helpers";
import loginMiddleware from "./validations/loginMiddleware";
import { withTranslation } from "react-i18next"; // Import withTranslation

const styles = (theme) => ({});

class AdminLoginForm extends Component {
    constructor(props) {
        super(props);

        this.props.change("loginType", "admin");
    }

    render() {
        const { classes, handleSubmit, t } = this.props; // Destructure t from props

        return (
            <React.Fragment>
                <form className={classes.form}>
                    <Field
                        name="email"
                        fullWidth
                        component={renderTextField}
                        label={t("email")} /* Translate "E-mail" */
                    />
                    <Field
                        name="password"
                        type="password"
                        fullWidth
                        component={renderTextField}
                        label={t("password")} /* Translate "Парола" */
                    />
                    <Button
                        fullWidth
                        variant="contained"
                        type="submit"
                        color="primary"
                        className="next"
                        style={{ marginTop: 10 }}
                        onClick={handleSubmit(loginMiddleware)}
                    >
                        {t("login")} {/* Translate "Вход" */}
                    </Button>
                </form>
            </React.Fragment>
        );
    }
}

//AdminLoginForm.propTypes = {
//    classes: PropTypes.object.isRequired,
//    t: PropTypes.func.isRequired, // Add t to propTypes
//};

export default withStyles(styles)(
    withTranslation()( // Wrap the component with withTranslation
        reduxForm({
            form: "AdminLoginForm", // a unique identifier for this form
            destroyOnUnmount: true, // preserve form data
            validate,
        })(AdminLoginForm)
    )
);

//import React, { Component } from 'react';
//import { Button } from '@material-ui/core';
//import withStyles from '@material-ui/core/styles/withStyles';
//import { Field, reduxForm } from 'redux-form';
//import validate from './validations/loginValidate';
//import { renderTextField } from '../../../helpers';
//import loginMiddleware from './validations/loginMiddleware';

//const styles = theme => ({
//});

//class AdminLoginForm extends Component {
//    constructor(props) {
//        super(props)

//        this.props.change("loginType", 'admin');
//    }

//    render() {
//        const { classes, handleSubmit } = this.props;

//        return (
//            <React.Fragment>
//                <form className={classes.form}>
//                    <Field
//                        name="email"
//                        fullWidth
//                        component={renderTextField}
//                        label="E-mail"
//                    />
//                    <Field
//                        name="password"
//                        type="password"
//                        fullWidth
//                        component={renderTextField}
//                        label="Парола"
//                    />
//                    <Button
//                        fullWidth
//                        variant="contained"
//                        type="submit"
//                        color="primary"
//                        className="next"
//                        style={{ marginTop: 10 }}
//                        onClick={handleSubmit(loginMiddleware)}
//                    >
//                        Вход
//                    </Button>
//                </form>
//            </React.Fragment>
//        );
//    }
//}

//export default withStyles(styles)(reduxForm({
//    form: 'AdminLoginForm', // a unique identifier for this form
//    destroyOnUnmount: true, // preserve form data
//    validate
//})(AdminLoginForm));